<template>
  <nav class="navigation">
    <router-link
      v-for="item in items"
      :key="item.name"
      class="navigation__item"
      :to="{ name: item.name, params: { dietType, dietId } }"
    >
      {{ item.label }}
      <Badge v-if="item.isNew" color="purple" size="sm">Nowość</Badge>
    </router-link>
  </nav>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'

  import { Badge } from '@/components/ui'
  import { useFeatureFlags } from '@/utils/flags'

  import type { DietType } from '@/store/types'

  const props = defineProps<{ dietId: number; dietType: DietType }>()
  const { isDietSettingsAnnouncementEnabled } = useFeatureFlags()
  const items = computed(() => [
    { label: 'Grafik', name: 'DietDetailWeek' },
    { label: 'Lista zakupów', name: 'DietDetailShoppingList' },
    { label: 'Komentarze', name: 'DietDetailComments' },
    ...(props.dietType === 'system'
      ? []
      : [
          { label: 'Założenia jadłospisu', name: 'DietDetailAssumptions' },
          {
            label: 'Ustawienia jadłospisu',
            name: 'DietDetailSettings',
            isNew: isDietSettingsAnnouncementEnabled.value,
          },
        ]),
  ])
</script>

<style scoped>
  .navigation {
    display: flex;
    flex-grow: 1;
    flex-direction: row;
  }

  .navigation__item {
    align-items: center;
    display: flex;
    gap: 6px;
    padding: 10px 8px;
    margin-right: 14px;
    font-family: Montserrat-Medium;
    font-size: 14px;
    line-height: 18px;
    color: var(--color-tertiary-text);
    white-space: nowrap;
    text-decoration: none;
    border-bottom: 4px solid transparent;
  }

  .navigation__item:hover,
  .navigation__item.router-link-active {
    color: var(--color-primary-text);
  }

  .navigation__item.router-link-active {
    border-bottom-color: var(--color-main-100);
  }
</style>
